import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const TIRE_ADD_FORM_SCHEMA = yup.object().shape({
  width: yup.string().required("Molimo Vas da odaberete širinu"),
  height: yup.string().required("Molimo Vas da odaberete visinu"),
  radius: yup.string().required("Molimo Vas da odaberete radius"),
  tireTypeId: yup.string().required("Molimo Vas da odaberete tip gume"),
  tireManufacturerId: yup.string().required("Molimo Vas da odaberete proizvođača"),
  quantity: yup.string().required("Molimo Vas da odaberete količinu"),
});
